
  var _styles = {
  "single-card-container": {
    "width": "9.36rem",
    "height": "3.2rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "marginTop": "0.24rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "single-card-image-view": {
    "borderRadius": "0.16rem",
    "width": "2.72rem",
    "height": "2.72rem",
    "overflow": "hidden",
    "position": "relative",
    "margin": "0.24rem"
  },
  "single-card-deal-title": {
    "marginTop": "0.24rem",
    "maxWidth": "5.92rem",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "lineHeight": "0.45333rem",
    "color": "rgb(34,34,34)",
    "fontWeight": "700",
    "height": "0.93333rem",
    "overflow": "hidden"
  },
  "single-card-image": {
    "width": "2.72rem",
    "height": "2.72rem"
  },
  "double-card-image-shadow": {
    "position": "absolute",
    "opacity": 0.6,
    "width": "4.56rem",
    "height": "0.64rem",
    "bottom": 0
  },
  "single-card-pos": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.16rem",
    "marginBottom": "0.16rem"
  },
  "single-card-pos-icon": {
    "width": "0.25333rem",
    "height": "0.284rem",
    "marginRight": "0.10667rem"
  },
  "single-card-pos-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.29333rem",
    "color": "rgb(102,102,102)",
    "lineHeight": "0.32rem",
    "fontWeight": "400"
  },
  "single-card-tag-field": {
    "marginTop": "0.08rem",
    "marginRight": 0,
    "marginBottom": "0.08rem",
    "marginLeft": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "single-card-discount-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "600"
  },
  "single-card-sale-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "single-card-discount-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "backgroundColor": "rgb(255,39,39)",
    "marginRight": "0.08rem"
  },
  "single-card-sale-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "400"
  },
  "single-card-sale-tag-image": {
    "height": "0.42667rem",
    "marginRight": "0.08rem"
  },
  "single-card-bottom-field": {
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "-0.24rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.32rem",
    "marginLeft": 0,
    "justifyContent": "space-between",
    "alignItems": "flex-end",
    "width": "5.89333rem"
  },
  "single-card-price-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "single-card-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "marginBottom": "-0.13333rem"
  },
  "single-card-price-icon": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.32rem",
    "fontWeight": "500"
  },
  "single-card-price-start": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,51,51)",
    "lineHeight": "0.34667rem",
    "fontWeight": "400",
    "marginLeft": "0.02667rem",
    "marginBottom": "0.13333rem"
  },
  "single-card-origin-price": {
    "marginBottom": "-0.06667rem",
    "marginLeft": "0.06667rem"
  },
  "single-card-btn": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem"
  },
  "single-card-btn-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.42667rem",
    "fontWeight": "600"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2_0', 'url("https://s3plus.meituan.net/v1/mss_098f084b61e744a0ae960d755eaad45e/meishi-yingxiao/fonts/max-icon/MTfin-Regular2.0.ttf")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  